import React, { useState, useEffect } from "react";
import Tabs from "../../../components/Tabs/Tabs";
import { Box, Typography } from "@mui/material";
import AdminPageLayout from "../../../components/FullPageLayout/AdminPageLayout";
import { useTranslation } from "react-i18next";
import RolesPermissionsSettings from "./RolesPermissionsSettings";
import GlobalAssignmentSettings from "./GlobalAssignmentSettings";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Route, Redirect } from "react-router-dom";
import {
  featureSettings,
  featureSettingsRolesPermissions,
  featureSettingsGlobalAssignment
} from "../../../routes/AdminRoutes";
import usePermissions from "../../../redux/selectors/usePermissions";

const FeatureSettings = ({ history }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { allowValidate, allowGlobalAssignmentSettings } = usePermissions();

  const tabs = [];
  if (allowValidate) {
    tabs.push({
      tabLabel: t("rolesPermissionsSettings.tabHeader"),
      tabSubtitle: t("rolesPermissionsSettings.cutomizeManageEmployeeHeader"),
      path: featureSettingsRolesPermissions
    });
  }
  if (allowGlobalAssignmentSettings) {
    tabs.push({
      tabLabel: t("globalAssignmentSettings.tabHeader"),
      path: featureSettingsGlobalAssignment
    });
  }

  const defaultRedirect = allowValidate
    ? featureSettingsRolesPermissions
    : featureSettingsGlobalAssignment;

  const handleTabChange = newTab => {
    setCurrentTab(newTab);
    dispatch(push(tabs[newTab].path));
  };

  useEffect(() => {
    const tab = tabs.findIndex(
      ({ path }) => path === history.location.pathname
    );
    if (tab !== -1) {
      setCurrentTab(tab);
    }
  }, [history]);

  return (
    <AdminPageLayout hideDivider>
      <Tabs
        tabs={tabs.map(({ tabLabel }) => tabLabel)}
        currentTab={currentTab}
        onChange={newTab => handleTabChange(newTab)}
        scrollButtons={false}
        textVariant="h6"
        disableHighlight
      />
      <Box py={4} display="flex" flexDirection="column">
        <Typography sx={{ pb: 3 }} variant="h5">
          {tabs[currentTab].tabSubtitle}
        </Typography>
        <Route
          path={featureSettings}
          exact
          render={() => <Redirect to={defaultRedirect} />}
        />
        {allowValidate && (
          <Route
            exact
            path={featureSettingsRolesPermissions}
            component={RolesPermissionsSettings}
          />
        )}
        {allowGlobalAssignmentSettings && (
          <Route
            exact
            path={featureSettingsGlobalAssignment}
            component={GlobalAssignmentSettings}
          />
        )}
      </Box>
    </AdminPageLayout>
  );
};

export default FeatureSettings;
